import { globalNormalDialogProxy } from '../../elements/Dialog/GlobalNormalDialog';
import { translate } from '../../i18n';
import { navigate } from '../navigationService';

export default () => {
  globalNormalDialogProxy.open({
    positiveText: translate('contactToService'),
    negativeText: translate('got-it'),
    contentText: translate('block-message'),
    handleDialogPositiveAction: () => navigate('SupportPage'),
  });
};
